export default "__VITE_ASSET__BOb1nA1m__"